import React, { Component } from "react";
import {
  Alert,
  FormGroup,
  FormControl,
  ControlLabel,
  Button
} from "react-bootstrap";
import LoginAPI from "../api/LoginAPI";
import UserAPI from "../api/UserAPI";

import "../css/Login.css";

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: "",
      password: "",
      response: null
    };
  }

  handleUsernameChange = (event) => {
    this.setState({ username: event.target.value });
  }

  handlePasswordChange = (event) => {
    this.setState({ password: event.target.value });
  }

  handleEnterPress = (event) => {
    if (event.key === "Enter") {
      this.login();
    }
  }

  login = () => {
    LoginAPI.login({
      username: this.state.username,
      password: this.state.password
    })
      .then(result => {
        localStorage.setItem("access_token", result.access_token);
        return UserAPI.getCurrentUser();
      })
      .then(user => {
        localStorage.setItem("user", JSON.stringify(user));
        return UserAPI.getUserGroups(user.id);
      })
      .then(groups => {
        localStorage.setItem("groups", JSON.stringify(groups));

        this.setState({
          response: {
            code: "OK",
            message: "Successfully logged in"
          }
        });

        this.props.onLogin();

        if (JSON.parse(localStorage.getItem("user")).isAdmin) {
          this.props.history.push("/users");
        } else {
          this.props.history.push("/swaggers");
        }
      })
      .catch(err => {
        this.setState({
          response: {
            code: err.errorCode,
            message: 'Wrong username or wrong password'
          }
        });
      });
  }

  render() {
    let alert 
    if (this.state.response) {
      alert = (<Alert bsStyle={this.state.response.code === "OK" ? 'success' : 'danger'}>{this.state.response.message}</Alert>)
    }

    return (
      <div className="login-div">
        <form className="login-form" onKeyPress={this.handleEnterPress}>
          {alert}
          <FormGroup>
            <ControlLabel>Username</ControlLabel>
            <FormControl
              className="form-input"
              id="username"
              type="text"
              placeholder="Enter your username"
              onChange={this.handleUsernameChange}
            />
          </FormGroup>
          <FormGroup>
            <ControlLabel>Password</ControlLabel>
            <FormControl
              className="form-input"
              id="password"
              type="password"
              placeholder="Enter your password"
              onChange={this.handlePasswordChange}
            />
          </FormGroup>
          <Button bsStyle="success" onClick={this.login}>
            Submit
          </Button>
        </form>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login.js